import { Effect, RequestResolver } from 'effect';
import * as TenantSchema from './schema';
import * as Url from '../../../api/url';
import { GetTenantsError } from './requests';
export const GetTenantsResolver = (http, url) => RequestResolver.fromEffect((_request) => http.get(Url.join(url, '/api/v1/tenants')).pipe(Effect.flatMap(res => TenantSchema.parse(res.body)), Effect.mapError(error => new GetTenantsError(error))));
